class RelatedProductsSwiper {
  constructor() {
    this.swipers = new Map();
    this.init();
  }

  init() {
    // Wait for product recommendations to load
    this.observeRecommendations();
  }

  observeRecommendations() {
    const recommendationElements = document.querySelectorAll('product-recommendations');
    
    recommendationElements.forEach((element) => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && element.querySelector('.swiper')) {
            this.initSwiper(element);
            observer.disconnect();
          }
        });
      });

      observer.observe(element, { childList: true, subtree: true });

      // Check if already loaded
      if (element.querySelector('.swiper')) {
        this.initSwiper(element);
        observer.disconnect();
      }
    });
  }

  initSwiper(recommendationElement) {
    const sliderComponent = recommendationElement.querySelector('slider-component');
    if (!sliderComponent) return;

    const sectionId = sliderComponent.dataset.sectionId;
    const key = `related-products-${sectionId}`;             // <-- use one key
    const enableDesktopSlider = sliderComponent.dataset.enableDesktopSlider === 'true';

    const isMobile = window.innerWidth < 750;
    if (!enableDesktopSlider && !isMobile) return;

    if (this.swipers.has(key)) {                             // <-- destroy with same key
      try { this.swipers.get(key).destroy(true, true); } catch (e) {}
      this.swipers.delete(key);
    }

    const config = this.getSwiperConfig(sliderComponent);
    const swiperContainer = sliderComponent.querySelector(`.related-products-swiper-${sectionId}`);
    if (!swiperContainer) { console.warn(`No swiper container for ${sectionId}`); return; }

    const swiper = new Swiper(swiperContainer, config);
    this.swipers.set(key, swiper);                           // <-- store with same key
    this.addCustomEvents(swiper, sliderComponent, sectionId);
  }


  getSwiperConfig(sliderComponent) {
    const columnsDesktop = parseInt(sliderComponent.dataset.columnsDesktop) || 4;
    const columnsMobile = parseInt(sliderComponent.dataset.columnsMobile) || 2;
    const enableAutoplay = sliderComponent.dataset.enableAutoplay === 'true';
    const autoplayDelay = parseInt(sliderComponent.dataset.autoplayDelay) || 5000;

    const config = {
      slidesPerView: 'auto',
      spaceBetween: 20,
      loop: false,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: sliderComponent.querySelector('.slider-button--next'),
        prevEl: sliderComponent.querySelector('.slider-button--prev'),
      },
      scrollbar: {
        el: sliderComponent.querySelector(`.related-products-scrollbar-${sliderComponent.dataset.sectionId}`),
        hide: false,
        draggable: true,
        dragSize: 'auto',
        snapOnRelease: true
      },
      mousewheel: { forceToAxis: true, releaseOnEdges: true },
      breakpoints: {
        0: {
          slidesPerView: columnsMobile,
          slidesPerGroup: 1,
          spaceBetween: 15
        },
        750: {
          slidesPerView: Math.min(columnsMobile + 1, columnsDesktop),
          slidesPerGroup: 1,
          spaceBetween: 20
        },
        990: {
          slidesPerView: columnsDesktop,
          slidesPerGroup: 1,
          spaceBetween: 30
        }
      },
      on: {
        init: (swiper) => {
          this.updateSliderCounter(swiper, sliderComponent);
          setTimeout(() => swiper.update(), 100);
        },
        slideChange: (swiper) => {
          this.updateSliderCounter(swiper, sliderComponent);
        }
      }
    };

    // Add autoplay if enabled
    if (enableAutoplay) {
      config.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }

    return config;
  }

  updateSliderCounter(swiper, sliderComponent) {
    const current = sliderComponent.querySelector('.slider-counter--current');
    const total = sliderComponent.querySelector('.slider-counter--total');
    
    if (current) {
      current.textContent = swiper.activeIndex + 1;
    }
    
    if (total) {
      total.textContent = swiper.slides.length;
    }
  }

  addCustomEvents(swiper, sliderComponent, sectionId) {
    // Dispatch custom event when slide changes
    swiper.on('slideChange', () => {
      const event = new CustomEvent('related-products:slide-changed', {
        detail: {
          sectionId: sectionId,
          activeIndex: swiper.activeIndex,
          slidesCount: swiper.slides.length
        }
      });
      sliderComponent.dispatchEvent(event);
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new RelatedProductsSwiper();
  });
} else {
  new RelatedProductsSwiper();
}

// Re-initialize on section refresh (for theme editor)
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('product-recommendations')) {
    new RelatedProductsSwiper();
  }
});